var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { responsivePaddingVariants } from '../../css/responsiveWhitespace.css';
import { getSpacingClasses } from '../../utils/spacings';
import { cardStyles, basePaddingVariants, sectionPaddingVariants, sectionStyles } from './Card.css';
const CardComponent = React.forwardRef(function Card(_a, ref) {
    var { as, children, className, padding = 16 } = _a, rest = __rest(_a, ["as", "children", "className", "padding"]);
    const Component = as || 'div';
    const paddingClass = getSpacingClasses(padding, basePaddingVariants, responsivePaddingVariants);
    return (_jsx(Component, Object.assign({ className: cx(cardStyles, paddingClass, className) }, rest, { ref: ref, children: children })));
});
const CardSectionComponent = React.forwardRef(function Card(_a, ref) {
    var { as, children, className, padding = 16 } = _a, rest = __rest(_a, ["as", "children", "className", "padding"]);
    const Component = as || 'div';
    return (_jsx(Component, Object.assign({ className: cx(sectionStyles, sectionPaddingVariants[padding], className) }, rest, { ref: ref, children: children })));
});
export const Card = CardComponent;
Card.Section = CardSectionComponent;
